import { get, putMultiPart, postMultiPart, deleteRequest, deleteWithPayload, post } from "../../../shared/data";

export const getPhotos = (wipKey) => {
    return get(`/photography/wips/${wipKey}/shots?isActive=true&includeMultipleImageEligibleShots=true`);
};

export const getRejectReasons = () => {
    return get("/photography/editing/reject-types").then((t) => {
        if (!t || !t.items) {
            return [];
        }

        return t.items.map((type) => {
            return {
                value: type.id,
                text: type.text,
                isRejectionReasonRequired: type.isRejectionReasonRequired,
            };
        });
    });
};

export const getDataTransferItems = (event) => {
    let dataTransferItemsList = [];

    if (event.dataTransfer) {
        const dt = event.dataTransfer;

        if (dt.files && dt.files.length) {
            dataTransferItemsList = dt.files;
        } else if (dt.items && dt.items.length) {
            // During the drag even the dataTransfer.files is null
            // but Chrome implements some drag store, which is accesible via dataTransfer.items
            dataTransferItemsList = dt.items;
        }
    } else if (event.target && event.target.files) {
        dataTransferItemsList = event.target.files;
    }

    // Convert from DataTransferItemsList to the native Array
    return Array.prototype.slice.call(dataTransferItemsList);
};

/*export const fileAccepted = (file, accept) => {
    return file.type === 'application/x-moz-file' || accepts(file, accept)
}
  
export const fileMatchSize = (file, maxSize, minSize) => {
    return file.size <= maxSize && file.size >= minSize
}*/

//Images
export const uploadImage = (wipKey, taskKey, shotKey, sourcePage, payload) => {
    return putMultiPart(`/photography/wips/${wipKey}/shots/${shotKey}/image?taskKey=${taskKey}&sourcePage=${sourcePage}`, payload);
};

// Create Group Shot
export const createGroupShot = (wipKey, taskKey, sourcePage, payload) => {
    return postMultiPart(
        `/photography/wips/${wipKey}/wip-shots?uploadEditedAndUneditedShot=true&taskKey=${taskKey}&sourcePage=${sourcePage}`,
        payload
    );
};

// Delete Group Shot
export const deleteGroupShot = async (wipKey, shotKey) => {
    return deleteRequest(`/photography/wips/${wipKey}/shots/${shotKey}/unedited`);
};

export const deleteEditedShot = (wipKey, taskKey, shotKey) => {
    return deleteRequest(`/photography/wips/${wipKey}/shots/${shotKey}/edited?taskKey=${taskKey}`);
};

export const getShotTemplate = (wipKey) => {
    return get(`/photography/wips/${wipKey}/template`);
};

export const redoPhotography = (taskId, sourcePage) => {
    return post(`/receiving/final/${taskId}/re-photography?sourcePage=${sourcePage}`).catch((e) => {
        return false;
    });
};

export const uploadUnidentifiedImage = (wipKey, sourcePage, formData) => {
    return postMultiPart(`/photography/wips/${wipKey}/wip-shots-edited?sourcePage=${sourcePage}`, formData, { passthrough: true });
};

export const updateLocaleReference = (photoWipKey, shotKey, payload) => {
    return post(`/photography/wips/${photoWipKey}/shots/${shotKey}/wip-shots-reference`, payload);
};

export const removeLocaleReference = (photoWipKey, shotKey, payload) => {
    return deleteWithPayload(`/photography/wips/${photoWipKey}/shots/${shotKey}/wip-shots-reference`, payload);
};

export const removeUneditedShots = (payload) => {
    return deleteWithPayload(`/photography/wips/shots/unedited`, payload);
};

export const removeEditedShots = (payload) => {
    return deleteWithPayload(`/photography/wips/shots/edited`, payload);
};
